export default {"src":"/_next/static/media/noun-prohibit-dark-white.c8e98ee3.svg","height":16,"width":16};